import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/home";
import Product from "./pages/product";
import Products from "./pages/products";
import Partners from "./pages/partners";
import Partner from "./pages/partner";
import Contact from "./pages/contact";

import AddProduct from "./pages/Admin/AddProduct";
import Footer from "./components/Footer";
import AddPartner from "./pages/Admin/AddPartners";

//fixed routing bug by following this link https://render.com/docs/deploy-create-react-app#using-client-side-routing

function App() {
  return (
    <Router>
        <Navbar></Navbar>
        <div className="pt-[45px] md:pt-[75px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="partner/:id" element={<Partner />}/>
            <Route path="/contact" element={<Contact/>}/>

            <Route path="/addProduct" element={<AddProduct />} />
            <Route path="/addPartner" element={<AddPartner />} />
          </Routes>
        </div>
        <Footer></Footer>
    </Router>
  );
}

export default App;
